import { ErrorMessage } from "@hookform/error-message"
import React, { KeyboardEvent } from "react"
import { useFormContext } from "react-hook-form"
import styled from "styled-components"
import FormLabel from "~/components/atoms/FormLabel"
import ErrorField from "./ErrorField"

type Props = {
  placeholder?: string
  value?: string
  min?: number
  max?: number
  name: string
  onChange: (params: {}) => any | null
  isConfirm?: boolean
  disabled?: boolean
  className?: string
  autoComplete?: string
  unit?: string
  isFormat?: boolean
  title?: string
  validations?: {
    required?: boolean
    maxLength?: number
  }
  error?: string
  onKeyUp?: (e: KeyboardEvent) => void
}

export default function AcNumreic(props: Props) {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const {
    onChange = null,
    placeholder = "",
    min,
    max,
    value = "",
    name,
    className = "",
    isConfirm = false,
    disabled = false,
    unit = "",
    isFormat = false,
    title,
    validations,
    error,
    onKeyUp,
  } = props

  const options: any = {}

  if (validations?.required) {
    Object.assign(options, {
      required: !disabled ? `${error || name}を入力してください` : false,
    })
  }
  if (validations?.maxLength) {
    Object.assign(options, {
      maxLength: {
        value: validations.maxLength,
        message: `${error || name}は${validations.maxLength}文字以下で入力してください`,
      },
    })
  }

  return isConfirm ? (
    <>
      <FormLabel>
        {value != null ? (
          <>
            {!!title && <span>{title}&nbsp;&nbsp;&nbsp;&nbsp;</span>}
            {isFormat ? new Intl.NumberFormat("ja-JP").format(Number(value)) : value}
            {unit}
          </>
        ) : (
          "ー"
        )}
      </FormLabel>
    </>
  ) : (
    <>
      <Input className={className} {...register(name, options)}>
        <input
          type="text"
          className={`${disabled ? "disabled" : ""}`}
          disabled={disabled}
          placeholder={placeholder}
          minLength={min}
          maxLength={max}
          name={name}
          onKeyUp={onKeyUp}
          defaultValue={value === null ? "" : value}
          autoComplete={"off"}
          value={value}
          onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
            if (
              min &&
              (e.target.value === "" || e.target.value === null || e.target.value === undefined)
            ) {
              e.target.value = String(min)
            }
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            e.target.value = e.target.value.replace(/[^\d]/gi, "")
            if (e.target.value) {
              const n = Number(e.target.value)
              if (min) {
                if (n < min) {
                  e.target.value = String(min)
                }
              }
              if (max) {
                if (n > max) {
                  // e.target.value = String(max)
                  return
                }
              }
            }
            const value =
              e.target.value === null || e.target.value === "" || e.target.value === undefined
                ? null
                : Number(e.target.value)
            e.target.value = Number.isInteger(value) ? String(value) : ""
            onChange?.apply(this, [value])
          }}
        />
      </Input>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => <ErrorField>{message}</ErrorField>}
      />
    </>
  )
}

const Input = styled.div.attrs({
  type: "text",
})`
  input[type="text"] {
    font-size: 16px;
    display: block;
    width: 100%;
    border: 1px solid #bdbfc8;
    padding: 13px 10px;
    border-radius: 4px;
    background-color: #ffffff;

    :disabled {
      background-color: #e6e6e6 !important;
    }
  }
`
